<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-23 16:23:17
 * @Description: 保存标记
 * @LastEditors: Please set LastEditors
-->
<template>
  <div v-drag class="marker position-absolute" :style="{ right: right }">
    <el-card>
      <div slot="header" class="business_dialog_title m-b-5">
        <span class="fz-14">{{ title }}</span>
        <span
          class="iconfont icon-close cur-pointer position-absolute close_icon"
          @click="closeDialog('showEdit')"
        ></span>
      </div>
      <el-form
        class="h-100"
        label-position="right"
        label-width="80px"
        ref="formLabelAlign"
        :model="formLabelAlign"
        :rules="rules"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="formLabelAlign.name" :disabled="disableName"></el-input>
        </el-form-item>
        <el-form-item label="分享用户">
          <el-select
            v-model="formLabelAlign.sharePerson"
            popper-class="document_select-popper"
            :disabled="IsShareAll"
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-checkbox class="r m-b-10" v-model="IsShareAll" @change="personChange"
            >所有人</el-checkbox
          >
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="formLabelAlign.remark"></el-input>
        </el-form-item>
        <el-form-item class="r">
          <el-button type="primary" size="small" @click="onSubmit">确定</el-button>
          <el-button size="small" @click="closeDialog('showEdit')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import Marker from '@/services/marker'
import Behavior from '@/services/Behavior.js'
import { resetObjectValue } from '@/assets/js/commonUtil.js'

export default {
  props: {
    formLabelAlign: {
      type: Object,
      default: () => {
        return {
          markingId: '',
          name: '',
          remark: '',
          sharePerson: [],
          cameraPosition: '',
          fileId: '',
          markType: '',
        }
      },
    },
    imgUrl: {
      type: String,
    },
    title: {
      type: String,
    },
    disableName: {
      type: Boolean,
    },
    right: {
      type: String,
      defaulte: '410px',
    },
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  data() {
    return {
      textarea1: '',
      options: [],
      rules: {},
      IsShareAll: false, // 是否分享给所有人
      userInfo: Wiz.AuthHooks.GetUserInfo(),
    }
  },
  created() {
    // this.getUserList()
    if (this.title === '分享标记') {
      this.rules = {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        sharePerson: [{ required: true, message: '请选择被分享人', trigger: 'change' }],
      }
    } else {
      this.rules = {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
      }
    }
  },
  methods: {
    personChange(val) {
      if (val) {
        this.formLabelAlign.sharePerson = []
      }
    },
    closeDialog(val) {
      // 清空对象中的值
      resetObjectValue(this.formLabelAlign)
      // this.formLabelAlign = this.$options.props.formLabelAlign.default()
      this.$emit('closeComponents', val)
    },
    /**
     * @description: 保存标记或分享标记
     * @param {*}
     * @return {*}
     */

    onSubmit() {
      this.$refs.formLabelAlign.validate(async (valid) => {
        if (valid) {
          // 验证是否选择分享对象
          if (!this.IsShareAll && !this.formLabelAlign.sharePerson.length) {
            this.$message.warning('分享用户不能为空!')
            return
          }
          // 分享标记
          if (this.title === '分享标记') {
            const query = {
              twoAndThreeDimensionalMarkingIds: this.formLabelAlign.markingId.split(','),
              sharedPerson: this.formLabelAlign.sharePerson,
              remark: this.formLabelAlign.remark,
              createdUser: this.userInfo.sub,
              IsShareAll: this.IsShareAll,
              siteId: this.currentProject ? this.currentProject.id : ' ',
            }
            const res = await Marker.addShareMark(query)
            if (res && res.code === 0) {
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.message)
              return false
            }
          }
          // 保存标记
          if (this.title === '保存标记') {
            // 上传截图
            const file = await this.dataURLtoFile(this.imgUrl, `${this.formLabelAlign.name}.png`)
            const formData = new FormData()
            formData.append('SiteId', this.currentProject ? this.currentProject.id : ' ')
            formData.append('Remark', '二三维标记')
            _.forIn(
              {
                file,
              },
              (value, key) => {
                formData.append(key, value)
              }
            )
            const res = await Behavior.uploadFile(formData)
            if (res && res.success && res.dataList && !_.isEmpty(res.dataList)) {
              const query = {
                cameraPosition: this.formLabelAlign.cameraPosition,
                documentFileId: this.formLabelAlign.fileId, // 文件id
                markType: this.formLabelAlign.markType, // 标记类型 1为二维标记，2为三维标记
                name: this.formLabelAlign.name,
                screenshotAttachmentId: res.dataList[0].id, // 截图文件id
                sharedPerson: this.formLabelAlign.sharePerson,
                IsShareAll: this.IsShareAll,
                remark: this.formLabelAlign.remark,
                siteId: this.currentProject ? this.currentProject.id : ' ',
              }
              const resSaveMark = await Marker.saveMark(query)
              if (resSaveMark && resSaveMark.code === 0) {
                this.$message.success(resSaveMark.msg)
              } else {
                this.$message.error(resSaveMark.message)
                return false
              }
            }
          }
          this.$emit('closeComponents', 'end')
        } else {
          return false
        }
      })
    },
    /**
     * @description: 图片转文件
     * @param {*} dataurl
     * @param {*} filename
     * @return {*}
     */

    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /**
     * @description: 获取easc的用户列表
     * @param {*}
     * @return {*}
     */

    async getUserList() {
      const { data: res } = await axios.get(
        `${currentEnv.VUE_APP_EASC_SERVER}/app/getappusersasync/${currentEnv.VUE_APP_APP_ID}`
      )
      if (res && res.result === 0) {
        this.options = _.map(res.innerResponse, (el) => {
          return {
            value: el.Id,
            label: el.TrueName,
          }
        })
      }
    },
  },
}
</script>
>
<style lang="scss" scoped>

@import '../../../css/index.scss';
@import '../../../css/select.scss';
.marker {
  top: 66px;
  right: calc(50% - 225px);
  padding: 10px;
  height: 334px;
  width: 450px;
  z-index: 1;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
.close_icon {
  top: 12px;
  right: 18px;
}

/deep/ .el-card {
  &__body,
  &__header {
    padding: 10px;
  }
  &__body {
    height: 280px !important;
    background-color: rgba(24, 41, 72, 0.5) !important;
  }
  .el-textarea__inner {
    background-color: rgba(24, 41, 72, 0.5) !important;
    border: none;
    color: #fff;
  }
}
/deep/.el-select {
  width: 76%;
}
/deep/.el-card .el-input.is-disabled input,
.el-textarea.is-disabled textarea,
/deep/.el-checkbox {
  color: #fff !important;
}

</style>
